import { EMAIL_REGEXP } from 'lib/validators/validators';
import { DateTime } from 'luxon';
import * as yup from 'yup';
import { ECertificateDeliveryMethod } from './certificate-form.const';

const DD_YY_MMMM_REGEXP =
  /^(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.(20\d{2})$/g;

const REQUIRED_FIELD_MESSAGE = 'Обязательное поле';
const WRONG_EMAIL_ERROR = 'Неверный адрес почты';

export const validationSchema = yup.object().shape({
  fromEmail: yup
    .string()
    .required(REQUIRED_FIELD_MESSAGE)
    .email(WRONG_EMAIL_ERROR)
    .matches(EMAIL_REGEXP, 'Проверьте правильность ввода email'),
  message: yup.string().optional().default(''),
  total: yup.string().required(),
  recaptcha: yup.string().required('Подтвердите, что вы не робот').nullable(),
  deliveryMethod: yup.string().required(),
  toEmail: yup
    .string()
    .email(WRONG_EMAIL_ERROR)
    .matches(EMAIL_REGEXP, 'Проверьте правильность ввода email')
    .when('deliveryMethod', {
      is: ECertificateDeliveryMethod.email,
      then: yup.string().required(REQUIRED_FIELD_MESSAGE),
      otherwise: yup.string().optional(),
    }),
  deliveryDate: yup.string().when('deliveryMethod', {
    is: ECertificateDeliveryMethod.email,
    then: yup
      .string()
      .label('deliveryDate')
      .matches(
        DD_YY_MMMM_REGEXP,
        'Укажите корректную дату в формате дд.мм.гггг',
      )
      .test('test-date', function (value: string | undefined) {
        const { path, createError } = this;
        const date = DateTime.fromFormat(value || '', 'dd.MM.yyyy').toJSDate();
        const today = DateTime.now().startOf('day').toJSDate();

        if (date.toString() === 'Invalid Date') {
          return createError({ path, message: 'Такой даты не существует' });
        }

        return (
          date >= today ||
          createError({ path, message: 'Дата не должна быть в прошлом' })
        );
      })
      .required('Введите дату'),
    otherwise: yup.string().optional(),
  }),
});
